var SupportGoodsVoucherStatusAndNotesPresentation;

SupportGoodsVoucherStatusAndNotesPresentation = {
  editable: {
    status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>",
    notes: I18n.translate('js.modules.notes.editable_goods_voucher_notes_message')
  },
  not_editable: {
    available: {
      status: "Ready to print",
      notes: I18n.translate('js.modules.notes.not_editable_notes_message')
    },
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    expired: {
      status: "Expired",
      notes: ""
    },
    expired_unredeemed: {
      status: "Promotional value expired on <span class='utctime'>{{expiration_date}}</span>",
      notes: I18n.translate('js.modules.notes.not_editable_expired_unredeemed_message') + ", you can still redeem it at <strong>{{merchant_name}}</strong> for the amount you paid for it."
    },
    expired_redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    }
  }
};

module.exports = SupportGoodsVoucherStatusAndNotesPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9nb29kc192b3VjaGVyX21lc3NhZ2VzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ByZXNlbnRlcnMvZ29vZHNfdm91Y2hlcl9tZXNzYWdlcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSw2Q0FBQSxHQUNFO0VBQUEsUUFBQSxFQUNJO0lBQUEsTUFBQSxFQUFRLDBFQUFSO0lBQ0EsS0FBQSxFQUFPLElBQUksQ0FBQyxTQUFMLENBQWUsdURBQWYsQ0FEUDtHQURKO0VBR0EsWUFBQSxFQUNFO0lBQUEsU0FBQSxFQUNNO01BQUEsTUFBQSxFQUFRLGdCQUFSO01BQ0EsS0FBQSxFQUFPLElBQUksQ0FBQyxTQUFMLENBQWUsNkNBQWYsQ0FEUDtLQUROO0lBSUEsUUFBQSxFQUNFO01BQUEsTUFBQSxFQUFRLDBEQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0FMRjtJQVFBLE9BQUEsRUFDRTtNQUFBLE1BQUEsRUFBUSxTQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0FURjtJQVlBLGtCQUFBLEVBQ0U7TUFBQSxNQUFBLEVBQVEsK0VBQVI7TUFDQSxLQUFBLEVBQU8sSUFBSSxDQUFDLFNBQUwsQ0FBZSwwREFBZixDQUFBLEdBQTZFLGlHQURwRjtLQWJGO0lBZ0JBLGdCQUFBLEVBQ0U7TUFBQSxNQUFBLEVBQVEsMERBQVI7TUFDQSxLQUFBLEVBQU8sRUFEUDtLQWpCRjtHQUpGOzs7QUF3QkYsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
